/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebplaceholderpaste3Inputs */

const en_placewebplaceholderpaste3 = /** @type {(inputs: Placewebplaceholderpaste3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste the link to your website`)
};

const de_placewebplaceholderpaste3 = /** @type {(inputs: Placewebplaceholderpaste3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link zu deiner Website einfügen`)
};

/**
* | output |
* | --- |
* | "Paste the link to your website" |
*
* @param {Placewebplaceholderpaste3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebplaceholderpaste3 = /** @type {((inputs?: Placewebplaceholderpaste3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebplaceholderpaste3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebplaceholderpaste3(inputs)
	return de_placewebplaceholderpaste3(inputs)
});
export { placewebplaceholderpaste3 as "placeWebPlaceholderPaste" }